// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industry_layout__ThAYL {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
}
.industry_problem__vrMWv,
.industry_answer__f1V\\+S {
  border-radius: var(--radius-lg);
  padding: clamp(1.75rem, 1rem + 3vw, 3.5rem);
}
.industry_problem__vrMWv {
  background: var(--color-cloud);
}
.industry_answer__f1V\\+S {
  background: var(--color-ink);
  color: #fff;
  border-radius: 0 var(--radius-lg) var(--radius-lg) var(--radius-lg);
}
.industry_eyebrow__wGan-,
.industry_eyebrowDark__W6kna {
  margin: 0 0 var(--space-4);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.industry_eyebrow__wGan-::before,
.industry_eyebrowDark__W6kna::before {
  content: "";
  width: 2rem;
  height: 2px;
  background: var(--kur-gold);
}
.industry_eyebrowDark__W6kna {
  color: var(--color-text-muted-on-dark);
}
.industry_title__zgQ3K {
  margin: 0;
  font-size: var(--text-h3);
  font-weight: 500;
  line-height: var(--leading-heading);
  text-wrap: balance;
}
.industry_stats__C8iiy {
  margin: var(--space-6) 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5);
}
.industry_stat__9q2GD {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  gap: var(--space-2);
  padding-top: var(--space-4);
  border-top: 2px solid var(--color-ink);
}
.industry_statValue__FHz7R {
  margin: 0;
  font-size: clamp(3rem, 2rem + 4vw, 5.5rem);
  line-height: 1;
  font-weight: 500;
  letter-spacing: var(--tracking-figure);
  color: var(--color-ink);
}
.industry_statText__Of2U\\+ {
  font-size: 0.95rem;
  line-height: 1.45;
  color: var(--color-text-muted);
}
.industry_question__xsD8h {
  margin: 0;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  font-style: italic;
  color: var(--color-text);
}
.industry_answerTitle__EAva1 {
  margin: 0 0 var(--space-5);
  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);\$1letter-spacing: var(--tracking-subheading);
}
.industry_answerText__OjU2r {
  margin: 0 0 var(--space-4);
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}
.industry_promiseLabel__jJN5S {
  margin: var(--space-6) 0 var(--space-3);
  font-size: var(--text-caption);
  color: var(--color-text-muted-on-dark);
}
.industry_promises__BQYFG {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  /* as many columns as fit a whole pill label */
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  gap: var(--space-2);
}
.industry_promises__BQYFG li {
  white-space: nowrap;
  padding: 0.75rem 1rem;
  border-radius: var(--radius-md);
  background: rgba(255, 255, 255, 0.06);
  border-left: 3px solid var(--kur-gold);
  font-weight: 500;
}

@media (min-width: 992px) {
  .industry_layout__ThAYL {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SPONSORS/SECTIONS/INDUSTRY/industry.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;;EAEE,+BAA+B;EAC/B,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,mEAAmE;AACrE;AACA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,kDAAkD,CAAC,4CAA4C;AACjG;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,2DAA2D;EAC3D,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF","sourcesContent":[".layout {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n}\n.problem,\n.answer {\n  border-radius: var(--radius-lg);\n  padding: clamp(1.75rem, 1rem + 3vw, 3.5rem);\n}\n.problem {\n  background: var(--color-cloud);\n}\n.answer {\n  background: var(--color-ink);\n  color: #fff;\n  border-radius: 0 var(--radius-lg) var(--radius-lg) var(--radius-lg);\n}\n.eyebrow,\n.eyebrowDark {\n  margin: 0 0 var(--space-4);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.eyebrow::before,\n.eyebrowDark::before {\n  content: \"\";\n  width: 2rem;\n  height: 2px;\n  background: var(--kur-gold);\n}\n.eyebrowDark {\n  color: var(--color-text-muted-on-dark);\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h3);\n  font-weight: 500;\n  line-height: var(--leading-heading);\n  text-wrap: balance;\n}\n.stats {\n  margin: var(--space-6) 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5);\n}\n.stat {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: flex-end;\n  gap: var(--space-2);\n  padding-top: var(--space-4);\n  border-top: 2px solid var(--color-ink);\n}\n.statValue {\n  margin: 0;\n  font-size: clamp(3rem, 2rem + 4vw, 5.5rem);\n  line-height: 1;\n  font-weight: 500;\n  letter-spacing: var(--tracking-figure);\n  color: var(--color-ink);\n}\n.statText {\n  font-size: 0.95rem;\n  line-height: 1.45;\n  color: var(--color-text-muted);\n}\n.question {\n  margin: 0;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  font-style: italic;\n  color: var(--color-text);\n}\n.answerTitle {\n  margin: 0 0 var(--space-5);\n  font-size: clamp(1.75rem, 1.25rem + 1.4vw, 2.4rem);$1letter-spacing: var(--tracking-subheading);\n}\n.answerText {\n  margin: 0 0 var(--space-4);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n.promiseLabel {\n  margin: var(--space-6) 0 var(--space-3);\n  font-size: var(--text-caption);\n  color: var(--color-text-muted-on-dark);\n}\n.promises {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  /* as many columns as fit a whole pill label */\n  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));\n  gap: var(--space-2);\n}\n.promises li {\n  white-space: nowrap;\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-md);\n  background: rgba(255, 255, 255, 0.06);\n  border-left: 3px solid var(--kur-gold);\n  font-weight: 500;\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `industry_layout__ThAYL`,
	"problem": `industry_problem__vrMWv`,
	"answer": `industry_answer__f1V+S`,
	"eyebrow": `industry_eyebrow__wGan-`,
	"eyebrowDark": `industry_eyebrowDark__W6kna`,
	"title": `industry_title__zgQ3K`,
	"stats": `industry_stats__C8iiy`,
	"stat": `industry_stat__9q2GD`,
	"statValue": `industry_statValue__FHz7R`,
	"statText": `industry_statText__Of2U+`,
	"question": `industry_question__xsD8h`,
	"answerTitle": `industry_answerTitle__EAva1`,
	"answerText": `industry_answerText__OjU2r`,
	"promiseLabel": `industry_promiseLabel__jJN5S`,
	"promises": `industry_promises__BQYFG`
};
export default ___CSS_LOADER_EXPORT___;
